<div class="content severity-page">
  <div class="container-fluid">
    <div class="severity-page-header">
      <div>
        <h1>Severity Configuration</h1>
        <p>Manage client severity levels, score deductions, and automatic-failure thresholds.</p>
      </div>

      <button
        *ngIf="canEdit"
        type="button"
        class="btn btn-primary severity-add-btn"
        (click)="openCreate()">
        <i class="fa-solid fa-plus mr-1"></i>
        Add Severity
      </button>
    </div>

    <div class="severity-metrics-grid">
      <div class="severity-metric-card">
        <div class="severity-metric-icon metric-blue"><i class="fa-solid fa-tags"></i></div>
        <div>
          <span>Total Severities</span>
          <strong>{{ totalCount }}</strong>
        </div>
      </div>

      <div class="severity-metric-card">
        <div class="severity-metric-icon metric-green"><i class="fa-solid fa-circle-check"></i></div>
        <div>
          <span>Active</span>
          <strong>{{ activeCount }}</strong>
        </div>
      </div>

      <div class="severity-metric-card">
        <div class="severity-metric-icon metric-red"><i class="fa-solid fa-triangle-exclamation"></i></div>
        <div>
          <span>Auto-Failure Enabled</span>
          <strong>{{ automaticFailureCount }}</strong>
        </div>
      </div>

      <div class="severity-metric-card">
        <div class="severity-metric-icon metric-purple"><i class="fa-solid fa-shield"></i></div>
        <div>
          <span>No Auto-Failure</span>
          <strong>{{ noAutomaticFailureCount }}</strong>
        </div>
      </div>
    </div>

    <div class="severity-table-card">
      <div class="severity-table-heading">
        <div>
          <h2>Client Severities</h2>
          <p>Deduction and failure thresholds are frozen into each audit revision when it is created.</p>
        </div>
      </div>

      <div class="severity-loading" *ngIf="loading">
        <span class="spinner-border spinner-border-sm mr-2"></span>
        Loading severity configuration...
      </div>

      <div class="table-responsive">
        <table class="table table-sm severity-table">
          <thead>
            <tr>
              <th>Severity</th>
              <th>Deduction</th>
              <th>Auto-Fail After</th>
              <th>Status</th>
              <th *ngIf="canEdit">Action</th>
            </tr>
          </thead>

          <tbody>
            <tr
              *ngFor="let item of severities; trackBy: trackBySeverityId"
              [class.severity-inactive]="!item.active">
              <td>
                <span class="severity-name">{{ item.name }}</span>
              </td>
              <td>
                <span class="deduction-badge">{{ formatDeduction(item) }}</span>
              </td>
              <td>{{ formatFailureCount(item) }}</td>
              <td>
                <span
                  class="status-badge"
                  [class.status-active]="item.active"
                  [class.status-inactive]="!item.active">
                  {{ item.active ? 'Active' : 'Inactive' }}
                </span>
              </td>
              <td *ngIf="canEdit">
                <button
                  type="button"
                  class="btn btn-sm btn-outline-primary severity-edit-btn"
                  (click)="openEdit(item)">
                  <i class="fa-solid fa-pen mr-1"></i>
                  Edit
                </button>
              </td>
            </tr>

            <tr *ngIf="!loading && severities.length === 0">
              <td [attr.colspan]="canEdit ? 5 : 4" class="severity-empty">
                No severities are configured for this client.
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>

    <div class="severity-modal-backdrop" *ngIf="editorOpen">
      <div class="severity-editor-modal">
        <div class="severity-editor-header">
          <div>
            <h3>{{ editor.id === null ? 'Add Severity' : 'Edit Severity' }}</h3>
            <p>Configure the deduction and optional automatic-failure threshold.</p>
          </div>
          <button type="button" class="severity-close-btn" (click)="closeEditor()">
            <i class="fa-solid fa-xmark"></i>
          </button>
        </div>

        <div class="severity-editor-body">
          <div class="severity-field">
            <label>Severity Name <span>*</span></label>
            <input
              type="text"
              [(ngModel)]="editor.name"
              maxlength="50"
              placeholder="e.g. CRITICAL">
          </div>

          <div class="severity-editor-grid">
            <div class="severity-field">
              <label>Deduction % <span>*</span></label>
              <input
                type="number"
                [(ngModel)]="editor.deductionPercent"
                min="0"
                max="100"
                step="0.01"
                placeholder="e.g. 5">
              <small>Percentage deducted when a question with this severity fails.</small>
            </div>

            <div class="severity-field">
              <label>Auto-Fail After Errors</label>
              <input
                type="number"
                [(ngModel)]="editor.failureCount"
                min="1"
                step="1"
                placeholder="Leave blank for never">
              <small>Leave blank when this severity should never automatically fail an audit.</small>
            </div>
          </div>

          <div class="severity-active-row" *ngIf="editor.id !== null">
            <div>
              <strong>Active Severity</strong>
              <span>Inactive severities remain visible but cannot be used for new configuration.</span>
            </div>
            <label class="severity-switch">
              <input type="checkbox" [(ngModel)]="editor.active">
              <span></span>
            </label>
          </div>
        </div>

        <div class="severity-editor-footer">
          <button
            type="button"
            class="btn btn-outline-secondary"
            (click)="closeEditor()"
            [disabled]="saving">
            Cancel
          </button>

          <button
            type="button"
            class="btn btn-primary"
            (click)="saveSeverity()"
            [disabled]="saving">
            <span *ngIf="saving" class="spinner-border spinner-border-sm mr-1"></span>
            {{ editor.id === null ? 'Create Severity' : 'Save Changes' }}
          </button>
        </div>
      </div>
    </div>
  </div>
</div>
